import { useModalContext } from '@/components/ui/modal-provider';

export const useModal = () => {
    const { openModal, openWizardModal, closeModal, isOpen } = useModalContext();
    return { openModal, openWizardModal, closeModal, isOpen };
};
